<template>
  <DxPopup
    :visible="visible"
    :show-title="true"
    :title="$t('common.new') + ' ' + $t('common.products')"
    width="80%"
    height="85%"
    :wrapper-attr="{ class: 'create-product-dialog-popup' }"
    @hiding="close"
  >
    <div class="create-product-dialog-content">
      <ProductAddOrEditContent
        :key="contentKey"
        :product-data="formData"
        @onProductSaved="onProductSaved"
        @onGotoListProduct="close"
      />
    </div>
  </DxPopup>
</template>

<script>
import DxPopup from "devextreme-vue/popup";
import ProductAddOrEditContent from "@/pages/stock-management/sm-products/partials/ProductAddOrEditContent.vue";

export default {
  name: "CreateProductDialog",
  components: { DxPopup, ProductAddOrEditContent },
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: this.emptyProductData(),
      contentKey: 0,
    };
  },
  watch: {
    visible(value) {
      if (value) {
        this.resetForm();
      }
    },
  },
  methods: {
    emptyProductData() {
      return {
        is_editable: true,
        is_active: 1,
        lot_management: 0,
        name: null,
        product_type: null,
        measure_unit_id: null,
      };
    },
    resetForm() {
      this.formData = this.emptyProductData();
      this.contentKey += 1;
    },
    close() {
      this.$emit("close");
    },
    onProductSaved(product) {
      this.$emit("saved", product);
      this.close();
    },
  },
};
</script>

<style lang="scss">
.create-product-dialog-popup {
  z-index: 3001 !important;
}

.create-product-dialog-popup .dx-popup-content {
  padding: 0 !important;
}

.create-product-dialog-popup .dx-overlay-content {
  z-index: 3001 !important;
}

.create-product-dialog-content {
  width: 100%;
  height: 100%;
  min-height: 450px;
}
</style>